import { Component } from '@angular/core';

@Component({
  selector: 'app-create-client',
  template: `
    <p>
      create-client works!
    </p>
  `,
  styles: ``
})
export class CreateClientComponent {

}
